import React, { useLayoutEffect } from "react";
import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import EventGallery from "../components/eventgallery/eventgallery";
import BottomBanner from "../components/bottombanner/bottombanner";
import QuoteBanner from "../components/quotebanner/quotebanner";
import TopEventGallery from "../components/topeventgallery/topeventgallery";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";

function SaiEventsPage() {
  useLayoutEffect(() => {
   document.title = 'Sathya Sai Events and Gallery - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
  }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Sai Gallery" pic="/images/activity.jpg" />
        <TopEventGallery />
        <Menucardforallpage />
        <EventGallery />
        <QuoteBanner />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default SaiEventsPage;